import { DateTime } from 'luxon';
import moment from 'moment';

export const timeFormat = (date?: Date) => {
  return moment(date).format('HH:mm');
};

export const dateFormat = (date?: Date | string) => {
  return moment(date).format('DD.MM.YYYY');
};

export const datetimeFormat = (date?: Date) => {
  return moment(date).format('DD.MM.YYYY, HH:mm');
};

export const filenameDatetimeFormat = (date?: Date) => {
  return moment(date).format('DD-MM-YYYY_HH-mm');
};

export const formatDate = (date: string, format?: string) => {
  return DateTime.fromISO(date).toFormat(format ?? 'dd.MM.yyyy');
};
